export enum CardAudioVariant {
  Card = 'card',
  Lightbox = 'lightbox',
}

export type CardAudioProps = {
  variant?: CardAudioVariant;
  isPlaying?: boolean;
};
